import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import {
  CurrentProductService,
  ICON_TYPE,
  LaunchDialogService,
} from '@spartacus/storefront'
import { Observable, of } from 'rxjs'
import {
  AuthService,
  GlobalMessageType,
  GlobalMessageService,
} from '@spartacus/core'
import { switchMap, debounceTime, take, filter } from 'rxjs/operators'
import { PDPService } from '../services/pdp.services'
import { ActivatedRoute } from '@angular/router'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { CommonService } from '../../../shared/services/common.service'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
import { Product } from '../../../models/product.model'

@Component({
  standalone: false,
  selector: 'vs-custom-product-summary',
  templateUrl: './custom-product-summary.component.html',
  styleUrls: ['./custom-product-summary.component.scss'],
})
export class CustomProductSummaryComponent implements OnInit {
  // product$: Observable<any>;
  product$: Observable<Product | any> = this.currentProductService.getProduct()
  iconTypes = ICON_TYPE
  view = 'pdp'
  public availableAt = 'Conde, France DRESSER PRODUCTS INDUSTRIES LIMITED'
  currentUser: any
  favStatus: boolean
  id: any
  product: any

  constructor(
    private currentProductService: CurrentProductService,
    public auth: AuthService,
    private commonService: CommonService,
    public pdpService: PDPService,
    private activatedRoute: ActivatedRoute,
    private globalMessageService: GlobalMessageService,
    private cd: ChangeDetectorRef,
    public spinnerOverlayService: SpinnerOverlayService,
    private userAccountFacade: UserAccountFacade,
    private launchDialogService: LaunchDialogService
  ) {}

  user$ = this.auth.isUserLoggedIn().pipe(
    switchMap((isUserLoggedIn) => {
      if (isUserLoggedIn) {
        return this.userAccountFacade.get()
      } else {
        return of(undefined)
      }
    })
  )

  ngOnInit(): void {
    // this.activatedRoute.paramMap.subscribe((value:any) =>{
    //   this.id =value.params.productCode});
    //   this.product$ = this.pdpService.getProduct(this.id);
    this.product$.subscribe((response) => {
      if (response !== null && response !== undefined) {
        this.favStatus = response['favouritesFlag']
        this.cd.detectChanges()
      }
      this.spinnerOverlayService.hide()
    })
  }

  updateFavioriteProduct(product, value?) {
    //make a call - POST/PUT API - to update the favorite status of the product
    this.pdpService
      .updateProductFavouriteStatus(product, value)
      .pipe(debounceTime(500))
      .subscribe(
        (response) => {
          if (response !== undefined) {
            switch (response.toString()) {
              case 'true':
                this.favStatus = true
                this.cd.markForCheck()
                break
              case 'false':
                this.favStatus = false
                this.cd.markForCheck()
                break
              case 'maxlimitreached':
                this.favStatus = false
                this.cd.markForCheck()
                this.displayMaxFavAttainedMsg()
                break
            }
          }
        },
        (error) => {
          this.favStatus = !this.favStatus //revert the status which you had updated before the API call.
          // this.cd.markForCheck();
          this.globalMessageService.add(
            { key: 'pdp.issueWhileTryingToUpdate' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  onFavoriteClick(product) {
    // My favourites dialog box
    if (!this.favStatus) {
      const componentdata = {}

      const favouritePdpDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.MY_FAVOURITES_PDP,
        undefined,
        undefined,
        componentdata
      )
      if (favouritePdpDialog) {
        favouritePdpDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose
          .pipe(
            filter(
              (dialogResponse: DialogResponse) =>
                dialogResponse?.type == VS_LAUNCH_CALLER.MY_FAVOURITES_PDP
            ),
            take(1)
          )
          .subscribe((value) => {
            if (value?.data?.myfavdescription) {
              this.favStatus = !this.favStatus //display to end user - that the product has changed his fav status
              this.updateFavioriteProduct(
                product,
                value?.data?.myfavdescription
              )
            }
          })
      }
    } else {
      this.favStatus = !this.favStatus
      this.updateFavioriteProduct(product)
    }
  }

  displayMaxFavAttainedMsg() {
    this.globalMessageService.add(
      { key: 'pdp.maximumItemsAdded' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }
}
